import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectDeliveryType {
  showPopup: Subject<void> = new Subject<void>();
  constructor() {}
}
